/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Desc_TeamsInputs */



/**
* | output |
* | --- |
* | "Create teams, assign members, and manage permissions across your organization." |
*
* @param {Plan_Gate_Desc_TeamsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_desc_teams = /** @type {((inputs?: Plan_Gate_Desc_TeamsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Desc_TeamsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie Teams, weisen Sie Mitglieder zu und verwalten Sie Berechtigungen in Ihrer Organisation.")
	return /** @type {LocalizedString} */ ("Create teams, assign members, and manage permissions across your organization.")
});